import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{outlet}}",{ moduleName: "walden-fast/templates/app/services/walden-box/index.hbs" })